/*************************************************/
/* FILTER                                        */
/*************************************************/
import mixitup from "mixitup";
export function filter() {
    const filterSelector = '.filter';
    const filterInputSelector = '.filter__dropdown';

    const getValueForFiltering = (value) => {
        let filterTarget = value;
        if(filterTarget == "") {
            filterTarget = "all";
        }else {
            filterTarget = '.' + filterTarget;
        }
        return filterTarget;
    }

    const updateQuery = (key,value) => {
        if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search);

            if (value !== "") {
                searchParams.set(key, value);
            } else {
                searchParams.delete(key);
            }

            var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.replaceState(null, '', newRelativePathQuery);
        }
        
    }

    const init = () => {
       const filter = document.querySelector(filterSelector);
       const filterInput = filter ? filter.querySelector(filterInputSelector) : null;
       const queryParameters = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });

       if(filter && filterInput) {
            const filterTargetsContainerSelector = filter.dataset.filterTargetsContainerSelector;
            const filterQueryKey = filter.dataset.filterQueryKey;
            if(filterTargetsContainerSelector && filterQueryKey) {
                const mixer = mixitup(filterTargetsContainerSelector);

                    //Running once on load
                    if(queryParameters[filterQueryKey]) {
                        const filterValue = getValueForFiltering(queryParameters[filterQueryKey]);
                        mixer.filter(filterValue);

                        let optionIndex = 0;
                        const options = filterInput.querySelectorAll('option');
                        for (let i = 0; i < options.length; i++) {
                            console.log(options[i].value);
                            console.log(queryParameters[filterQueryKey]);
                            if(options[i].value == queryParameters[filterQueryKey]) optionIndex = i;
                        }
                        filterInput.selectedIndex = optionIndex;
                    }else if(filterInput.value != "") {
                        mixer.filter(getValueForFiltering(filterInput.value));
                    }

                    //Listens to change
                    filterInput.addEventListener('change', e => {
                        mixer.filter(getValueForFiltering(e.target.value));
                        updateQuery(filterQueryKey,e.target.value);
                    });
            }
       }
    };

    init();

}

